import React, { Component } from "react";
import Layout from "./Layout";

import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import "react-bootstrap-table-next/dist/react-bootstrap-table2.min.css";
import "react-bootstrap-table2-paginator/dist/react-bootstrap-table2-paginator.min.css";


class Organigramas extends Component {
  constructor(props) {
    super(props);
    this.state = {

    };
  }

  render() {
    return (
      <Layout>
        <ToastContainer />

        <br />
        <h3>Organigrama Ambito {this.props.match.params.ambito_id}</h3>
        <object
          data={"http://143.198.191.211/pdf/organigramas/" + this.props.match.params.ambito_id + ".pdf"}
          type="application/pdf"
          width="100%"
          height="80%"
        >
          <p>
            Tu navegador no soporta este componente{" "}
            <a href={"http://143.198.191.211/pdf/organigramas/" + this.props.match.params.ambito_id + ".pdf"}>
              Descárgalo
            </a>
          </p>
        </object>

      </Layout >
    );
  }
}

export default Organigramas;
